module.exports = __webpack_public_path__ + "img/img4.a43b0366.png";